import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.9584 7.29427L11.5417 5.8776L8.00004 9.41927L6.22921 7.64844L2.54171 11.3359M2.33337 2.33594V13.6693H13.6667",
      stroke: "currentColor",
      "stroke-linecap": "square"
    }, null, -1)
  ])))
}
export default { render: render }